import { fetchDatas } from '../../../services/axiosInstanceService';
import { citiesParser } from '../subscriptionParser';

const fetchCitiesByPattern = async (
  subscriptionIdIri: string | null,
  pattern: string,
) => {
  try {
    if (subscriptionIdIri && pattern) {
      if (pattern.length >= 3) {
        const result = await fetchDatas(`${subscriptionIdIri}/cities`, {
          name: pattern,
          page: 1,
        });

        const parsedCities = citiesParser(result['hydra:member']);

        return parsedCities;
      } else {
        return Promise.reject('pattern to short');
      }
    } else {
      return Promise.reject('param not found');
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

export { fetchCitiesByPattern };
